<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-9">
            <h4 class="card-title">{{ $t("malware.upload-file") }}</h4>
            <p class="card-title-desc">{{ $t("malware.upload-malware") }}.</p>
          </div>
          <div class="col-3 text-right">
            <b-button class="mr-3" variant="primary" @click="historyUploadModal"
              >History Upload</b-button
            >
            <b-modal
              id="modal-history-upload"
              size="xl"
              centered
              :title="$t('malware.history-upload')"
              title-class="font-18"
              @ok="getPreferences"
              hide-footer
            >
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body p-3">
                      <!-- <div class="card-title text-center">
                        <h4>{{ $t("malware.history-upload") }}</h4>
                      </div> -->
                      <div class="row">
                        <div class="col-6 mt-2">
                          <!-- <h5>{{ $t("malware.history-upload") }}</h5> -->
                        </div>
                        <div class="col-6 mt-2 text-right">
                          <h5>
                            {{ $t("malware.total-upload") }} :
                            {{ total_upload }}
                          </h5>
                        </div>
                        <div class="col-12">
                          <div class="py-3">
                            <div class="row">
                              <div class="col-6">
                                <div
                                  id="tickets-table_length"
                                  class="dataTables_length"
                                >
                                  <label
                                    class="d-inline-flex align-items-center"
                                  >
                                    {{ $t("table.show_label") }}&nbsp;&nbsp;
                                    <b-form-select
                                      v-model="perPage"
                                      size="sm"
                                      :options="pageOptions"
                                      class="mx-1"
                                    ></b-form-select
                                    >&nbsp;&nbsp;{{ $t("table.entri_label") }}
                                  </label>
                                </div>
                              </div>
                              <!-- Search -->
                              <div class="col-6">
                                <div
                                  id="tickets-table_filter"
                                  class="dataTables_filter text-md-right"
                                >
                                  <label
                                    class="d-inline-flex align-items-center"
                                  >
                                    {{ $t("table.search_label") }}:
                                    <b-form-input
                                      v-model="filter"
                                      type="search"
                                      :placeholder="$t('navbar.search.text')"
                                      class="form-control form-control-md ml-2"
                                    ></b-form-input>
                                  </label>
                                </div>
                              </div>
                              <!-- End search -->
                              <!-- Table -->
                              <div class="table-responsive mb-0 px-2">
                                <b-table
                                  :items="tableData"
                                  :fields="fields"
                                  bordered
                                  responsive="sm"
                                  :per-page="perPage"
                                  :current-page="currentPage"
                                  :sort-desc.sync="sortDesc"
                                  :filter="filter"
                                  :filter-included-fields="filterOn"
                                  @filtered="onFiltered"
                                >
                                  <template #cell(no)="row">
                                    <span>{{ row.index + 1 }}</span>
                                  </template>
                                  <template #cell(sandbox)="row">
                                    <span v-if="row.item.sandbox == 'ahn_lab'"
                                      >AHN Lab</span
                                    >
                                    <span v-if="row.item.sandbox == 'cp_lab'"
                                      >Checkpoint</span
                                    >
                                    <span
                                      v-if="
                                        row.item.sandbox !== 'cp_lab' &&
                                        row.item.sandbox !== 'ahn_lab'
                                      "
                                      >{{ row.item.sandbox }}</span
                                    >
                                  </template>
                                  <template #cell(created_at)="row">
                                    <span>{{
                                      formatDate(row.item.created_at)
                                    }}</span>
                                  </template>
                                  <template #cell(running_vm)="row">
                                    <div v-if="row.item.sandbox == 'ahn_lab'">
                                      <span v-if="row.item.running_vm == 'vm1'"
                                        >Windows XP</span
                                      >
                                      <span v-if="row.item.running_vm == 'vm2'"
                                        >Windows 7</span
                                      >
                                      <span v-if="row.item.running_vm == 'vm3'"
                                        >Windows 10</span
                                      >
                                      <span v-if="row.item.running_vm == 'vm4'"
                                        >Windows 11</span
                                      >
                                    </div>
                                    <div v-if="row.item.sandbox == 'cp_lab'">
                                      <span class="mr-2">Windows XP</span>
                                      <span>Windows 7</span>
                                    </div>
                                  </template>
                                  <template #cell(status)="row">
                                    <span
                                      class="badge badge-info p-1 px-1 badge-md rounded"
                                      variant="secondary"
                                      v-if="row.item.status == 0"
                                    >
                                      On Prosess</span
                                    >
                                    <span
                                      class="badge badge-success p-1 px-1 rounded"
                                      v-else-if="row.item.status == 1"
                                    >
                                      Done</span
                                    >
                                  </template>
                                </b-table>
                              </div>
                              <div class="row px-2" v-if="rows > 10">
                                <div class="col-2">
                                  <label
                                    class="d-inline-flex align-items-center"
                                  >
                                    Page
                                    <b-form-input
                                      v-model="currentPage"
                                      placeholder="Page"
                                      class="form-control w-10 form-control ml-2"
                                    ></b-form-input>
                                  </label>
                                </div>
                                <div class="col-10 text-right" v-if="rows > 10">
                                  <div
                                    class="dataTables_paginate paging_simple_numbers float-right"
                                  >
                                    <ul
                                      class="pagination pagination-rounded mb-0"
                                      :class="
                                        theme == 'dark'
                                          ? 'custom-paginate-dark'
                                          : 'custom-paginate'
                                      "
                                    >
                                      <!-- pagination -->
                                      <b-pagination
                                        v-model="currentPage"
                                        :total-rows="rows"
                                        :per-page="perPage"
                                      ></b-pagination>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-12 p-2 text-center">
                    <img
                      src="@/assets/images/upload.png"
                      width="150px"
                      alt=""
                      srcset=""
                    />
                    <h4 class="my-2 mt-3">Drag & Drop File to Upload</h4>
                  </div>
                  <div class="col-12">
                    <b-form-file
                      ref="malware_upload"
                      :state="fileValid"
                      @change="FileUpload"
                      :placeholder="$t('malware.file-placeholder')"
                      :drop-placeholder="$t('malware.drop-placeholder')"
                      :class="fileValid ? '' : 'is-invalid'"
                    ></b-form-file>
                  </div>
                </div>
              </div>
              <div class="col-md-6 px-4">
                <div
                  class="p-3"
                  :class="
                    theme == 'dark'
                      ? 'upload-setting-dark'
                      : 'upload-setting-light'
                  "
                >
                  <h4 class="text-right mb-3">Upload Setting</h4>
                  <div class="row">
                    <div class="col-12 mb-2">
                      <div class="form-group">
                        <label for="sandbox">Sandbox</label>
                        <select
                          class="custom-select"
                          id="sandbox"
                          v-model="select_sandbox"
                        >
                          <option value="" selected>
                            {{ $t("dashboards.select-sandbox") }}
                          </option>
                          <option value="1">Checkpoint</option>
                          <option value="2">AhnLab</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 mb-2">
                      <div class="form-group">
                        <label for="sandbox">Running VM</label>
                        <select
                          class="custom-select"
                          v-model="running_vm"
                          :disabled="select_sandbox == 1"
                          :class="select_sandbox == 1 ? 'text-muted' : ''"
                        >
                          <option value="" selected>
                            {{ $t("dashboards.select-vm") }}
                          </option>
                          <option value="vm1">Windows XP</option>
                          <option value="vm2">Windows 7</option>
                          <option value="vm3">Windows 10</option>
                          <option value="vm4">Windows 11</option>
                        </select>
                        <small class="text-danger" v-if="select_sandbox == 1"
                          >Checkpoint vm not support</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-4">
              <button
                type="button"
                class="btn"
                :class="
                  (select_sandbox == '2' && running_vm && file_upload) ||
                  (select_sandbox == '1' && file_upload)
                    ? 'btn-success'
                    : 'btn-outline-success disabled'
                "
                @click="uploadMalware"
              >
                <b-spinner
                  v-if="loading_upload"
                  label="loading_upload ..."
                  small
                ></b-spinner>
                <span v-if="!loading_upload">{{
                  $t("malware.upload-file")
                }}</span>
                <span v-if="loading_upload"> Loading.. </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { userService } from "@/helpers/authservice/user.service";
import PreferencesServices from "@/helpers/preferences.service";
import MalwareServices from "@/helpers/malware.service";
import moment from "moment";
import StatisticsService from "@/helpers/statistics.service";

/**
 * Projects-grid component
 */
export default {
  components: {},
  data() {
    return {
      // file_1: file1,
      loading_upload: false,
      sandbox_value: "all",
      select_sandbox: "",
      file_upload: "",
      theme: localStorage.getItem("theme") ?? "light",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      running_vm: "",
      fileValid: true,
      total_upload: 0,
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      theme: localStorage.getItem("theme") ?? "light",
      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },

        {
          key: "sandbox",
          sortable: true,
          label: "Sandbox ",
        },
        {
          key: "filename",
          sortable: true,
          label: this.$t("malware.file-name"),
        },
        {
          key: "filetype",
          sortable: true,
          label: this.$t("malware.file-type"),
        },
        {
          key: "running_vm",
          sortable: true,
          label: "Running VM",
        },

        {
          key: "created_at",
          sortable: true,
          label: this.$t("malware.upload-date"),
        },
        {
          key: "status",
          sortable: true,
          label: this.$t("malware.status"),
        },
      ],
    };
  },
  methods: {
    getPreferences() {
      PreferencesServices.getPreference()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferences();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.totalUser = [];
            let pref = response.data.data;
            pref.forEach((val) => {
              if (val.key == "ip_reputation") {
                this.pref_search_ip = {
                  id_pref: val.id_pref,
                  type: val.type,
                  key: val.key,
                  api_name: val.api_name,
                  api_host: val.api_host,
                  api_header_host: val.api_header_host,
                  api_header_key: val.api_header_key,
                };
              } else if (val.key == "whois") {
                this.pref_search_whois = {
                  id_pref: val.id_pref,
                  type: val.type,
                  key: val.key,
                  api_name: val.api_name,
                  api_host: val.api_host,
                  api_header_host: val.api_header_host,
                  api_header_key: val.api_header_key,
                };
              } else if (val.key == "whois2") {
                this.pref_search_whois2 = {
                  id_pref: val.id_pref,
                  type: val.type,
                  key: val.key,
                  api_name: val.api_name,
                  api_host: val.api_host,
                  api_header_host: val.api_header_host,
                  api_header_key: val.api_header_key,
                };
              }
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferences();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },
    FileUpload(evt) {
      this.file_upload = evt.target.files[0];
    },

    uploadMalware() {
      if (this.file_upload && this.select_sandbox) {
        if (this.select_sandbox == 1) {
          this.cpUpload();
        }
        if (this.select_sandbox == 2) {
          this.ahnUpload();
        }
      }
    },

    ahnUpload() {
      const formData = new FormData();
      formData.append("malware_file", this.file_upload, this.file_upload.name);
      formData.append("running_vm", this.running_vm);
      this.loading_upload = true;
      MalwareServices.uploadAhn(formData)
        .then((response) => {
          // console.log('res upload', response);
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.ahnUpload();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            if (response.data.data.is_exist) {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title:
                  response.data.message +
                  ". This file has already been uploaded",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("doSearch", {
                sandbox: this.select_sandbox,
                ...response.data.data,
              });
            } else {
              this.getHistoryUpload();
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
            this.file_upload = "";
            this.running_vm = "";
            this.select_sandbox = "";
            this.$refs.malware_upload.reset();
            this.$emit("finish-upload");
            this.loading_upload = false;
          }
        })
        .catch((err) => {
          console.log("err ->> ", err);
          if (err.response == undefined) {
            this.loading_upload = false;
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.ahnUpload();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            this.loading_upload = false;
          }
        });
    },

    cpUpload() {
      const formData = new FormData();
      formData.append("file", this.file_upload, this.file_upload.name);
      this.loading_upload = true;
      MalwareServices.uploadCp(formData)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.cpUpload();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            console.log("res cp Upload ", response);
            if (response.data.data.is_exist) {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title:
                  response.data.message +
                  ". This file has already been uploaded",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("doSearch", {
                sandbox: this.select_sandbox,
                ...response.data.data,
              });
            } else {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
            this.file_upload = "";
            this.running_vm = "";
            this.select_sandbox = "";
            this.$refs.malware_upload.reset();
            this.$emit("finish-upload");
            this.loading_upload = false;
          }
        })
        .catch((err) => {
          console.log("err ->> ", err);
          if (err.response == undefined) {
            this.loading_upload = false;
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.cpUpload();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            this.loading_upload = false;
          }
        });
    },

    uploadMalwareCheckpoint() {
      let ferr = 0;
      const data_request = {
        request: {
          features: ["te", "av", "extraction"],
          te: {
            reports_version_number: 2,
            reports: ["xml", "pdf", "summary"],
            extraction: {
              method: "pdf",
            },
          },
        },
      };
      const formData = new FormData();
      formData.append("malware_file", this.file_upload, this.file_upload.name);
      formData.append("request", data_request);
      // console.log("tes",  this.running_vm);
      if (this.file_upload && this.select_sandbox) {
        if (this.select_sandbox == 1) {
          Vue.swal({
            position: "top-end",
            icon: "info",
            title: "Comming Soon",
            showConfirmButton: false,
            timer: 3000,
          });
          this.file_upload = "";
          this.running_vm = "";
          this.select_sandbox = "";
          this.$refs.malware_upload.reset();
        }
        if (this.select_sandbox == 2) {
          this.loading_upload = true;
          MalwareServices.uploadAhn(formData)
            .then((response) => {
              // console.log('res upload', response);
              if (response.status == 201) {
                let new_token = response.data.refresh_access_token;
                userService.splitToken(new_token);
                this.uploadMalware();
                ferr = 1;
                this.$store.dispatch("notification/refreshtoken", "refresh");
              } else {
                this.getHistoryUpload();
                ferr = 2;
                if (response.data.data.is_exist) {
                  Vue.swal({
                    position: "top-end",
                    icon: "success",
                    title:
                      response.data.message +
                      ". This file has already been uploaded",
                    showConfirmButton: false,
                    timer: 2000,
                  });
                  this.$emit("doSearch", {
                    sandbox: this.select_sandbox,
                    ...response.data.data,
                  });
                } else {
                  Vue.swal({
                    position: "top-end",
                    icon: "success",
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                }
                this.file_upload = "";
                this.running_vm = "";
                this.select_sandbox = "";
                this.$refs.malware_upload.reset();
                this.$emit("finish-upload");
                this.loading_upload = false;
              }
            })
            .catch((err) => {
              console.log("err ->> ", err);
              if (err.response == undefined) {
                this.loading_upload = false;
                console.log("err ->> ", err);
              } else if (
                this.$store.state.notification.type === "refresh-token" &&
                err.response.status == 401
              ) {
                this.uploadMalware();
              } else {
                if (err.response.status == 401) {
                  userService.logout();
                } else {
                  console.log(err);
                }
                this.loading_upload = false;
              }
            });
        }
      }
    },
    historyUploadModal() {
      this.$bvModal.show("modal-history-upload");
    },
    getHistoryUpload() {
      console.log("history");
      let ferr = 0;
      StatisticsService.getHistoryReports()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getTotal();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.tableData = [];
            ferr = 2;
            console.log("res", response.data.data);
            this.total_upload = response.data.data.length;
            response.data.data.forEach((val, index) => {
              const data = {
                no: index + 1,
                id_queue: val.id_queue,
                sandbox: val.sandbox,
                running_vm: val.running_vm,
                id_malware: val.id_malware,
                md5: val.md5,
                filename: val.filename,
                filetype: val.filetype,
                upload_by: val.upload_by,
                status: val.status,
                analysis_time: val.analysis_time,
                created_at: val.created_at,
                updated_at: val.updated_at,
              };
              this.tableData.push(data);
              // this.loading = false;
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getTotal();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatDate(val) {
      return moment(val).format("YYYY-MM-DD, hh:mm");
    },
  },
  resetUpload() {},
  beforeMount() {
    this.getPreferences();
  },
  mounted() {
    this.getHistoryUpload();
  },
};
</script>
<style>
.upload-setting-dark {
  border: solid 2px #052a38;
  border-radius: 5px;
}
.upload-setting-light {
  border: solid 2px #a9acb9;
  border-radius: 5px;
}
</style>
